import { render, staticRenderFns } from "./DashboardCharts.vue?vue&type=template&id=1310a1d3&"
import script from "./DashboardCharts.vue?vue&type=script&lang=js&"
export * from "./DashboardCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Pipelines\\release\\07.00\\maintenance\\Fontes\\corp\\produto\\wes\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1310a1d3')) {
      api.createRecord('1310a1d3', component.options)
    } else {
      api.reload('1310a1d3', component.options)
    }
    module.hot.accept("./DashboardCharts.vue?vue&type=template&id=1310a1d3&", function () {
      api.rerender('1310a1d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/ui/DashboardCharts.vue"
export default component.exports